import React from 'react';
import { ChallengeTagProps, getTagConfig } from '@fitzaa/shared';

export const ChallengeTag: React.FC<ChallengeTagProps> = ({ level, isEligible = true, className = '' }) => {
    const config = getTagConfig(level);
    const opacity = isEligible ? 'opacity-100' : 'opacity-50';

    return (
        <span
            className={`
                inline-flex items-center px-2 py-1 rounded-full text-xs font-medium
                ${config.bgColor} ${config.textColor} ${config.borderColor}
                border ${opacity} ${className}
            `}
        >
            <span className="mr-1">{config.emoji}</span>
            {config.label}
        </span>
    );
}; 